var App = App || {};

App.WidgetHero = (function ($) {
    'use strict';

    function Init(widget) {
        InitParallax(widget);
        InitPromoCardAnimations(widget);
        InitPromoCardClickSupport(widget);

        const carousel = widget.find(".splide.hero-promos");
        if (!carousel.length)
            return false;

        InitCarousel(carousel);
    }

    function InitPromoCardAnimations(widget) {
        if (widget.hasClass("disable-animations")) {
            return;
        }

        const promosWrapper = widget.find(".hero-promos-wrapper");

        if (!promosWrapper.length) {
            return;
        }

        promosWrapper.ZagScrollAnimate({
            offset: 75,
            targets: [{ selector: ".shared-promo-card", type: "animate_fadeInUp", stagger: 250 }],
            overflow: false
        });
    }

    function InitPromoCardClickSupport(widget) {
        const promoCards = widget.find(".hero-promos .shared-promo-card");

        if (!promoCards.length) {
            return;
        }

        promoCards.off("click.widgetHeroPromoCard").on("click.widgetHeroPromoCard", function (e) {
            if ($(e.target).closest("a, button, input, select, textarea, label").length) {
                return;
            }

            const stretchedLink = $(this).find("a.stretched-link[href]").first();

            if (!stretchedLink.length) {
                return;
            }

            stretchedLink[0].click();
        });
    }

    function InitParallax(widget) {
        const backgroundLayer = widget.children(".hero-background-layer");

        if (backgroundLayer.children(".hero-background-image.zag-parallax-bg").length) {
            backgroundLayer.ZagParallax({ divisor: 2 });
        }
    }

    function InitCarousel(carousel) {
        const splide = new Splide(carousel[0], {
            type: 'slide',
            perPage: 3,
            perMove: 1,
            gap: '3rem',
            padding: { left: 0, right: 0 },
            pagination: false,
            arrows: false,
            breakpoints: {
                1399: {
                    perPage: 3,
                    gap: '2.4rem',
                },
                1199: {
                    perPage: 2,
                    gap: '2rem',
                    padding: { left: 0, right: 0 },
                },
                991: {
                    perPage: 1,
                    gap: '1.6rem',
                    padding: { left: 0, right: '22%' },
                },
                767: {
                    perPage: 1,
                    gap: '1.2rem',
                    padding: { left: 0, right: '28%' },
                },
                575: {
                    perPage: 1,
                    gap: '1rem',
                    padding: { left: 0, right: '34%' },
                },
            }
        });
        const wrapper = carousel.closest('.hero-promos-wrapper');
        const prevButton = wrapper.find('.splide__arrow--prev');
        const nextButton = wrapper.find('.splide__arrow--next');

        function updateArrowState() {
            const perPage = Number(splide.options.perPage) || 1;
            const canNavigate = splide.length > perPage;

            wrapper.toggleClass('hero-promos-wrapper--arrows-hidden', !canNavigate);

            if (!canNavigate) {
                prevButton.prop('disabled', true);
                nextButton.prop('disabled', true);
                return;
            }

            prevButton.prop('disabled', splide.index === 0);
            nextButton.prop('disabled', splide.index >= splide.length - perPage);
        }

        splide.on('mounted moved resized updated', updateArrowState);
        splide.mount();

        prevButton.on('click', function() {
            splide.go('<');
        });

        nextButton.on('click', function() {
            splide.go('>');
        });

        updateArrowState();
    }

    return {
        Init: Init
    };

})(jQuery);
